import React from 'react'
import { Modal } from '../../../../../components/common/Modal'
import { ModalHeader } from '../../../../../components/common/Modal/ModalHeader'
import { ModalBody } from '../../../../../components/common/Modal/ModalBody'
import { AdminListModalContent } from './AdminListModalContent'

interface AdminListModalProps {
  show: boolean
  close: () => void
  adminList?: string[]
}

export const AdminListModal = ({
  show,
  close,
  adminList,
}: AdminListModalProps): React.ReactNode => {
  return (
    <Modal show={show}>
      {{
        header: <ModalHeader onClose={close}>Admins</ModalHeader>,
        body: (
          <ModalBody className="overflow-y-auto">
            <AdminListModalContent adminList={adminList} />
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
